import { SupplierMappingTypeEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class SupplierCreationDto {
  @ApiProperty()
  supplierType : SupplierMappingTypeEnum;
  @ApiProperty()
  supplierId : number;
  @ApiProperty()
  userName : string;
  @ApiProperty()
  password : string;
}